module.exports = __webpack_public_path__ + "media/images/p4-28475032aad298c9aece511046e5ea31.jpg";